import { LessonActivity, LessonActivityModel } from "../../../modules/lesson/activity/activity.types"
import React, { useEffect, useState } from "react"
import { lllLookupService } from "../../../modules/lll/lll-lookup"
import { useNavigate } from "react-router-dom"
import { ActivityNode, LllMetadata } from "../../../modules/lll/lll-nodes"
import { LllNodeBranch } from "../../../modules/lll/lll-node-branch"
import { buildRelativeUrl } from "../../../common/utils/web-utils"
import lllIcon from "../../../assets/assets/images/services-icon/lll.svg"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { accessibleService } from "../../../modules/center-services/AccessibleService"
import awicon from "../../../assets/images/services-icon/coin.png"
import { SessionLessonData } from "../../../modules/lesson/activity/session"
import { onFlexi, sessionIsCompleted } from "../../../modules/lesson/activity/session-util"

type LllActivityCardProps = {
  activity: LessonActivity,
  sessionLessonData?: SessionLessonData,
}

export const LllActivityCard = (props: LllActivityCardProps) => {

  const {activity, sessionLessonData} = props;
  const [activityNode, setActivityNode] = useState<ActivityNode>();
  const [activityBranch, setActivityBranch] = useState<LllNodeBranch>();

  const [allowed, setAllowed] = useState<boolean>(true);
  const [showBlocked, setShowBlocked] = useState<boolean>(false);

  const navigate = useNavigate();

  const subject = activity.fk_sub_id
  const sessionKey = activity.fk_sest_key
  const activityModel = new LessonActivityModel(activity)

  function navigateToActivity() {
    const params = {
      session_key: sessionKey,
      subject: subject,
      homework: activity.marked_for_homework,
      mode: 'activity',
      activityKey: activity.pk_lesson_activity_key
    }
    const url = buildRelativeUrl(`/lll`, params);
    navigate(url);
  }

  useEffect(() => {
    lllLookupService.getActivityTree()
      .then(()=>{
        const _node = lllLookupService.findNodeByFqn(activity.activity_ref_id!);
        setActivityNode(_node as ActivityNode);
        const _branch = LllNodeBranch.createTo(_node);
        setActivityBranch(_branch);
      })
  }, [activity.activity_ref_id]);

    // Subscription gate
    useEffect(() => {
        (async () => {
            await accessibleService.init();
            setAllowed(accessibleService.hasAccessToEnrichment());
        })();
    }, []);

    const startOrShowGate = () => {
        if (!accessibleService.hasAccessToEnrichment()) {
            setAllowed(false);
            setShowBlocked(true);
            return;
        }

        navigateToActivity();
    }

    // const handleTitleClick = () => {
    //     if (activityModel.isCompleted()) return;
    //     startOrShowGate();
    // }

    function LllActivityAccess() {

      if(activity.marked_for_homework)
        return <LLLHomeworkActivityAccess />

      return <LllLessonActivityAccess/>
    }

    function LLLHomeworkActivityAccess() {

      if(!activity.marked_for_homework) return null;

      if(activityModel.isCompleted()) {
        return (
          <>
            <div className="d-flex align-items-center text-success fw-bold text-uppercase">
              <span className="mcr-success"></span>
              <span>Completed</span>
            </div>
          </>
        )
      }
      if(!activityModel.isCompleted()){
        return (
          <>
            <Button className={`text-uppercase ${allowed ? "btn btn-danger cs-btn-danger" : "btn btn-secondary"}`}
                      aria-disabled={!allowed}
                      title={allowed ? "Start" : "Unavailable — centre not subscribed"}
                      onClick={startOrShowGate}
                      style={!allowed ? { opacity: 0.65, cursor: "not-allowed" } : undefined}
              >
                Start
            </Button>
          </>)
      }
    }

    function LllLessonActivityAccess() {
      const sessionLesson = sessionLessonData?.session;

      if(activity.marked_for_homework || !sessionLesson) {
        return null;
      }

      if (parseInt(String(sessionLesson.ses_status)) !== 1){

        return(<>
          <div className="d-flex align-items-center text-dark fw-bold text-uppercase">
            <span>SESSION HAS NOT BEEN STARTED</span>
          </div>
        </>
      )}

      // if(sessionStarted(sessionLesson)){
      if(parseInt(String(sessionLesson.ses_status)) === 1){
        if ((!sessionIsCompleted(sessionLessonData) || onFlexi(sessionLessonData))
          && !activityModel.isCompleted()) {
          return (
            <>
              <Button className={`text-uppercase ${allowed ? "btn btn-danger cs-btn-danger" : "btn btn-secondary"}`}
                      aria-disabled={!allowed}
                      title={allowed ? "Start" : "Unavailable — centre not subscribed"}
                      onClick={startOrShowGate}
                      style={!allowed ? { opacity: 0.65, cursor: "not-allowed" } : undefined}
              >
                Start
              </Button>
            </>)
        }

        if ( sessionIsCompleted(sessionLessonData) && !onFlexi(sessionLessonData)
          && !activityModel.isCompleted()){
          return (<>
            <div className="d-flex align-items-center text-danger fw-bold text-uppercase">
              <span>Missed</span>
            </div>
          </>)
        }

        if(activityModel.isCompleted()) {
          return (
            <>
              <div className="d-flex align-items-center text-success fw-bold text-uppercase">
                <span className="mcr-success"></span>
                <span>Completed</span>
              </div>
            </>
          )
        }
      }

      return null;
    }

  return(
    <>
      <div className="d-flex align-items-start">
        <div className="hw-icon me-3">
          <img width={36} className="" src={lllIcon} alt="" />
        </div>
        <div
                    // className="cursor-pointer"
                    // onClick={handleTitleClick}
                    // onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleTitleClick()}
                    // role="button"
                    // tabIndex={0}
                >
          <p className="text-warning mb-2 fw-bold font-size-12 text-uppercase">
            {activityBranch?.topicDisplay}
          </p>

          <h4 className="fw-bold font-size-24">
            {activityBranch?.activityDisplay}
          </h4>

          <div className="d-flex align-items-center font-size-18 fw-medium me-3">
            <img width={24} className="me-2" src={awicon} alt="" />
            {activityModel.getCoinsEarned()??0}/{LllMetadata.coinsPerActivity} Coins
          </div>
        </div>
      </div>

      <div className="direct_link">
        <div className="hw-status text-end">
          <LllActivityAccess />
        </div>
      </div>

    <Modal isOpen={showBlocked} toggle={() => setShowBlocked(false)}>
        <ModalHeader toggle={() => setShowBlocked(false)}>Unavailable</ModalHeader>
            <ModalBody>
                Your centre is not subscribed to <b>Enrichment</b> for the current period. Please contact your centre
                for access.
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={() => setShowBlocked(false)}>
                    Close
                </Button>
            </ModalFooter>
    </Modal>
    </>

  )
}